import { render, staticRenderFns } from "./collapseCard.vue?vue&type=template&id=6bdec7e4&scoped=true"
import script from "./collapseCard.vue?vue&type=script&lang=js"
export * from "./collapseCard.vue?vue&type=script&lang=js"
import style0 from "./collapseCard.vue?vue&type=style&index=0&id=6bdec7e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdec7e4",
  null
  
)

export default component.exports